import getAttachment from '../selectors/getAttachment';
import type AttachmentId from 'owa-service/lib/contract/AttachmentId';
import { getTypeOfAttachment, TypeOfAttachment } from 'owa-attachment-type';

export function isLinkAttachment(attachmentId: AttachmentId): boolean {
    const attachment = getAttachment(attachmentId);
    const typeOfAttachment = getTypeOfAttachment(attachment?.model);
    return isLinkTypeAttachment(typeOfAttachment);
}

function isLinkTypeAttachment(attachmentType: TypeOfAttachment): boolean {
    return attachmentType === TypeOfAttachment.Link;
}
